import { RadioBtnProps } from "./RadioBtn";

const RoundCheckBox = ({
    text,
    name,
    color = "is-primary",
    checked = false,
    handleClick,
    className,
    style
}: RadioBtnProps) => {
    const id = Date.now().toString(36) + Math.random().toString(36);
    return (
        <div
            className={`round-checkbox is-small ${color} ${className}`}
            style={style}
        >
            <div>
                <input
                    type="checkbox"
                    id={id}
                    name={name}
                    checked={checked}
                    value={text}
                    onChange={() => handleClick && handleClick()}
                />
                <label htmlFor={id}></label>
            </div>
        </div>
    );
};

export default RoundCheckBox;
